<div class="plan-container">
  <app-plan></app-plan>
</div>
